// extracted by mini-css-extract-plugin
export default {"button":"CollapsibleButton-module__button--hs7s3","buttonText":"CollapsibleButton-module__buttonText--HE7hX"};